module.exports = __webpack_public_path__ + "static/media/PM GATISHAKTI TAG-Agenda.13825a34.svg";